import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Modal} from "react-bootstrap";
import {  LabelFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import PulseLoader from "react-spinners/PulseLoader";
import Select from 'react-select';
import { listAllUsers } from "../../APIs/UserRequests";
import { createTeam, getAllStates, getSettings, showTeam, updateTeam } from "../../APIs/TeamRequests";
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import { listRoles } from "../../APIs/RoleRequests";
import { getAllCities, getAllCountryStates } from "../../APIs/SettingRequests";
import TextWithIconFieldComponent from "../../components/fields/TextWithIconFieldComponent";

export default function TeamCreatePage() {
    const {id} = useParams();


    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState('');
    const [roles, setRoles] = useState([]);

    const [selectedRole, setSelectedRole] = useState(null);

    const [managers, setManagers] = useState([]);
    const [members, setMembers] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cityAreas, setCityAreas] = useState([]);
    const [countryAreas, setCountryAreas] = useState([]);

    const [nameError, setNameError] = useState('');
    const [managersError, setManagersError] = useState('');
    const [membersError, setMembersError] = useState('');
    const [areasError, setAreasError] = useState('');

    const [managersList, setManagersList] = useState([]);
    const [membersList, setMembersList] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [areasList, setAreasList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const [alertModal, setAlertModal] = useState(false);
    const [currentStateIndex, setCurrentStateIndex] = useState(0);

    const listManagersAction = (role) => {
        listAllUsers(role).then((res) => {
            setManagersList(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const listMembersAction = () => {
        listAllUsers().then((res) => {
            setMembersList(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const listUsersAction = () => {
        listAllUsers().then((res) => {
            setUsersList(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const listRolesAction = () => {
        listRoles().then((res) => {
            setRoles(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const getAllCitiesAction = (page=1) => {
        getSettings().then((res) => {
            const defaultCountry = res.data.data.find(setting => setting.key === 'default_country');
            if (defaultCountry) {
                getAllCities(defaultCountry.value, page, 10000).then((res) => {
                    setCitiesList(res.data.data.map(city => ({ value: city.id, label: city.name })));
                })
                getAllCountryStates(defaultCountry.value).then((res) => {
                    setCountryAreas(res.data.data);
                })
            }
        })
    }

    const getAllStatesAction = (cityId, page=1) => {
        getAllStates(cityId, page, 10000).then((res) => {
            setAreasList(res.data.data);
        });
    }

   
    useEffect(() => {
        listMembersAction();
        listRolesAction();
        getAllCitiesAction();
        listUsersAction();
        if(id){
            showTeamAction();
        }
    }, []);

    const showTeamAction = () => {
        showTeam(id).then((res) => {
            setName(res.data.data.name);
            setManagers(res.data.data.managers.map(manager => manager.id));
            setMembers(res.data.data.members.map(member => member.id));
            setAreas(res.data.data.areas.map(area => area.id));
            //console.log('managers', res.data.data.managers.map(manager => manager.id));
            //console.log('members', res.data.data.members.map(member => member.id));
            //console.log('areas', res.data.data.areas.map(area => area.id));
        }).catch((error) => {
            console.log(error);
        });
    }

    const handleSubmit = () => {
        setNameError('');
        setManagersError('');
        setMembersError('');
        setAreasError('');
        let hasError = false;
        if(name === ''){
            setNameError(t('team_name_required'));
            hasError = true;
        }
        if(areas.length === 0){
            setAreasError(t('areas_required'));
            hasError = true;
        }
        if(members.length === 0){
            setMembersError(t('members_required'));
            hasError = true;
        }

        if(hasError){
            return;
        }

        if(id){
            updateTeamAction();
        }else{
            createTeamAction();
        }
        
    }

    const createTeamAction = () => {
        setLoading(true)
        createTeam( name, managers, members, areas ).then((res) => {
            setName('');
            setManagers([]);
            setMembers([]);
            setAreas([]);
            const notify = () => toast.success(res.data.message);
            notify();
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    const updateTeamAction = () => {
        setLoading(true)
        updateTeam( id, name, managers, members, areas).then((res) => {
            const notify = () => toast.success(res.data.message);
            notify();
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }
    if(loading){
        return (
            <div className="mc-spinner">
                <img className="pattern" src="images/pattern.webp" alt="pattern" />
                <img className="favicon" src="images/logo.webp" alt="logo" />
                <div className="mc-spinner-group">
                    <h3>Loading</h3>
                    <PulseLoader 
                        color="#0857f5"
                        loading={loading} 
                        size={8} 
                    /> 
                </div>
            </div>
        );
    }else{
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className='mc-breadcrumb'>
                                <h3 className="mc-breadcrumb-title">{t('create_team')}</h3>
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className="mc-tab-card">
                                <Row>
                                    <Col xl={12}><LabelFieldComponent errorMessage={nameError} type="text" label={t('team_name')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>

                                </Row>
                                <Row>
                                    <Col xl={4} className="mb-4">
                                        <h6 className="mc-tab-card-title">{t('roles')}</h6>
                                        <Select
                                            defaultValue={selectedRole}
                                            name="colors"
                                            options={roles?.map(role => ({ value: role?.id, label: role?.name }))}
                                            value={selectedRole}
                                            placeholder={t('select_role')}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOptions) => {
                                                setSelectedRole(selectedOptions);
                                                listManagersAction(selectedOptions.value);
                                            }}
                                        />
                                    </Col>
                                    <Col xl={8} className="mb-4">
                                        <h6 className="mc-tab-card-title">{t('managers')}</h6>
                                        <Select
                                            defaultValue={managers}
                                            isMulti
                                            name="colors"
                                            options={managersList?.map(user => ({ value: user?.id, label: user?.name }))}
                                            value={managers.map(managerId => ({ value: managerId, label: usersList.find(user => user.id === managerId)?.name }))}
                                            placeholder={t('select_managers')}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOptions) => {
                                                setManagers(selectedOptions.map(option => option.value));
                                            }}
                                        />
                                        {
                                            managersError && <span className="mc-label-field"  style={{ color:'red',marginTop: '15px'}} >{managersError}</span>
                                        }
                                    </Col>
                                </Row> 
                                <Row>
                                    <Col xl={12} className="mb-4">
                                        <h6 className="mc-tab-card-title">{t('members')}</h6>
                                        <Select
                                            defaultValue={members}
                                            isMulti
                                            name="colors"
                                            options={membersList?.filter(user => !managers.includes(user.id)).map(user => ({ value: user?.id, label: user?.name }))}
                                            value={members.map(memberId => ({ value: memberId, label: usersList.find(user => user.id === memberId)?.name }))}
                                            placeholder={t('select_members')}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOptions) => {
                                                setMembers(selectedOptions.map(option => option.value));
                                            }}
                                        />
                                        {
                                            membersError && <span className="mc-label-field"  style={{ color:'red',marginTop: '15px'}} >{membersError}</span>
                                        }
                                    </Col>
                                </Row> 

                                <Row>
                                    <Col xl={4} className="mb-4">
                                        <h6 className="mc-tab-card-title">{t('city')}</h6>
                                        <Select
                                            defaultValue={citiesList}
                                            name="colors"
                                            options={citiesList}
                                            value={selectedCity}
                                            placeholder={t('select_city')}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOption) => {
                                                setSelectedCity(selectedOption);
                                                getAllStatesAction(selectedOption.value);
                                                setCityAreas([]);

                                            }}
                                        />
                                    </Col>
                                    <Col xl={8} className="mb-4">
                                        <h6 className="mc-tab-card-title">{t('areas')}</h6>
                                        <Select
                                            defaultValue={[]}
                                            isMulti
                                            name="colors"
                                            options={areasList.map(area => ({ value: area?.id, label: area?.name }))}
                                            value={cityAreas.map(areaId => ({ value: areaId, label: areasList.find(area => area.id === areaId)?.name }))}
                                            placeholder={t('select_areas')}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOptions) => {
                                                setCityAreas(selectedOptions.map(option => option.value));
                                            }}
                                        />
                                        {
                                            areasError && <span className="mc-label-field"  style={{ color:'red',marginTop: '15px'}} >{areasError}</span>
                                        }
                                    </Col>
                                    <ButtonComponent
                                        className="mc-btn primary"
                                        icon="verified"
                                        text={t('set')}
                                        onClick={()=>{
                                            const newAreas = cityAreas.filter(cityArea => !areas.includes(cityArea));
                                            setAreas([...areas, ...newAreas]);
                                        }}/>

                                </Row> 
                                <Col xl={12}>
                                    <div className="mc-label-field-group label-col" style={{ marginTop: '20px' }}>
                                    {
                                        
                                        areas.length>0 && areas.map((areaItem, index) => (
                                            <Col key={index} xl={4}>
                                                <TextWithIconFieldComponent
                                                    label={''}
                                                    fieldSize="w-100 h-md"
                                                    value={countryAreas.find(area => area.id == areaItem)?.name}
                                                    readOnly
                                                    icon="delete"
                                                    iconAction={()=>setAlertModal(true,setCurrentStateIndex(index))}
                                                    />
                                            </Col>
                                        ))
                                    }
                                    </div>
                                </Col>
                            </div>
                            <Modal show={ alertModal } onHide={()=> setAlertModal(false,setCurrentStateIndex(0))}>
                                <div className="mc-alert-modal">
                                    <i className="material-icons">new_releases</i>
                                    <h3>{t('are you sure!')}</h3>
                                    <p>{t('Want to delete this areas?')}</p>
                                    <Modal.Footer>
                                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>{t('close')}</ButtonComponent>
                                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> {
                                            const newAreas = areas.filter((item, i) => i !== currentStateIndex);

                                            setAreas(newAreas);
                                            setAlertModal(false,setCurrentStateIndex(0));
                                        }}>{t('delete')}</ButtonComponent>
                                    </Modal.Footer>
                                </div>
                            </Modal>
                            
                            <ButtonComponent className="mc-btn primary" icon="verified" text={id?t('update'):t('create')} onClick={()=>handleSubmit()}/>

                        </div>
                    </Col>
                </Row>
                
            </PageLayout>
        )
    }
    
}